import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Banner, useBannerSlot } from 'parent-portal/navigation';

interface RPreviewBannerProps {
    message: string;
    onBack: () => void;
    backLabel?: string;
}

export function RPreviewBanner({ message, onBack, backLabel = 'Back to Settings' }: RPreviewBannerProps) {
    const slot = useBannerSlot();
    if (!slot) return null;

    return ReactDOM.createPortal(
        <Banner variant="warning" badge="Preview Mode" action={<BackLink onClick={onBack}>← {backLabel}</BackLink>}>
            {message}
        </Banner>,
        slot,
    );
}

const BackLink = styled('button')({
    background: 'none',
    border: 'none',
    fontSize: 13,
    fontWeight: 500,
    color: Colors.darkNavy,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});
